export const formatCurrency = (num: number) =>
  `€${new Intl.NumberFormat('de-DE').format(num)}`;

export const formatCurrency2 = (
  num: number,
  { currencySign = '€' }: { currencySign?: string } = {
    currencySign: '€',
  },
) => {
  if (currencySign === '€') {
    return `${currencySign} ${new Intl.NumberFormat('de-DE').format(num)}`;
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(num);
};

export const formatCurrency3 = (
  num: number,
  { currency }: { currency: 'USD' | 'EUR' } = {
    currency: 'USD',
  },
) => {
  if (currency === 'EUR') {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency,
    }).format(num);
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(num);
};
